import React from 'react'

import cn from 'classnames'

import s from './ContentWrapper.module.scss'

type Props = {
  children: React.ReactNode
  className?: string
  style?: any
}

const ContentWrapper = ({ children, className, style }: Props) => {
  return (
    <div className={cn(s.overlay, 'scroll')}>
      <div
        className={cn(s.wrapper, className && s[`${className}`])}
        style={style}
      >
        {children}
      </div>
    </div>
  )
}

export default ContentWrapper
